import { BusinessPrinter } from 'types';
import { toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface SavedPrintersState {
  isInitialized: boolean;
  printers: BusinessPrinter[];
  requestInProgress: boolean;
}

const initialState: SavedPrintersState = {
  isInitialized: true,
  printers: [],
  requestInProgress: false,
};

export default function reducer(
  state: SavedPrintersState = initialState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any
): SavedPrintersState {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.SAVED_PRINTERS_FETCH_ALL_DONE:
      return {
        ...state,
        isInitialized: true,
        printers: toJSONArray<BusinessPrinter>(payload),
        requestInProgress: false,
      };

    case AppConstants.SAVED_PRINTERS_FETCH_ALL_FAILED:
      return {
        ...state,
        isInitialized: true,
        requestInProgress: false,
      };

    case AppConstants.SAVED_PRINTERS_DESTROY_FAILED:
    case AppConstants.SAVED_PRINTERS_CREATE_FAILED:
    case AppConstants.SAVED_PRINTERS_DESTROY_DONE:
    case AppConstants.SAVED_PRINTERS_CREATE_DONE: {
      return {
        ...state,
        requestInProgress: false,
      };
    }

    case AppConstants.SAVED_PRINTERS_DESTROY_STARTING:
    case AppConstants.SAVED_PRINTERS_CREATE_STARTING:
    case AppConstants.SAVED_PRINTERS_FETCH_ALL_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case AppConstants.SAVED_PRINTERS_RESET: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
}
